"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var InputTextGroup_1 = require("../InputTextGroup");
var styles_1 = require("./styles");
var CheckComponent = function (_a) {
    var id = _a.id, label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'right' : _b, helpText = _a.helpText, containerClassName = _a.containerClassName, className = _a.className, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.indeterminate, indeterminate = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, onChange = _a.onChange, type = _a.type, dataTestId = _a["data-testid"], inputProps = __rest(_a, ["id", "label", "labelPosition", "helpText", "containerClassName", "className", "checked", "indeterminate", "disabled", "onChange", "type", 'data-testid']);
    var _f = (0, react_1.useState)(false), hover = _f[0], setHover = _f[1];
    var checkRef = (0, react_1.useRef)(null);
    var isRight = (0, react_1.useMemo)(function () { return labelPosition === 'right'; }, [labelPosition]);
    var isCheckbox = (0, react_1.useMemo)(function () { return type === 'checkbox'; }, [type]);
    var componentClassNames = (0, react_1.useMemo)(function () { return (0, styles_1.getClasses)(type, !!disabled, hover, isCheckbox); }, [type, hover, disabled]);
    (0, react_1.useEffect)(function () {
        if (checkRef.current) {
            checkRef.current.checked = checked;
            checkRef.current.indeterminate = isCheckbox && indeterminate;
        }
    }, [checked, indeterminate]);
    var renderLabel = (0, react_1.useCallback)(function () {
        return label && ((0, jsx_runtime_1.jsx)(InputTextGroup_1.InputTextGroup, { label: label, helpText: helpText, "data-testid": dataTestId }));
    }, [label, helpText]);
    var handleChange = function (event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked);
    };
    var handleMouseEnter = function () {
        setHover(true);
    };
    var handleMouseLeave = function () {
        setHover(false);
    };
    return ((0, jsx_runtime_1.jsxs)("label", __assign({ className: (0, classnames_1.default)('indeterminate:squid-bg-alias-color-bg-primary', { 'squid-flex squid-gap-x-component-checkbox-space-base': !!label }, containerClassName), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: [!isRight && renderLabel(), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-p-1 squid-flex', {
                        'hover:squid-bg-alias-state-base-hover': hover && !disabled,
                        'squid-rounded-component-checkbox-border-radius': type === 'checkbox',
                        'squid-rounded-component-radio-border-radius': type === 'radio',
                    }) }, { children: (0, jsx_runtime_1.jsx)("input", __assign({ ref: checkRef, tabIndex: 0, id: id, type: type, disabled: disabled, "data-testid": dataTestId, "data-indeterminate": indeterminate }, inputProps, { onChange: handleChange, className: (0, classnames_1.default)('squid-border squid-border-alias-color-border-base', componentClassNames, className) })) })) }), isRight && renderLabel()] })));
};
exports.CheckComponent = CheckComponent;
